import { date } from "colbi_web_ui/lib/utils";
import { formatCurrencyValues } from "../../utils/convertUtils";
import { Buffer } from "buffer";
const mapCard = (json) => {
    const {
        AccountID,
        Description,
        CreditAmount,
        DebitAmount,
        TransactionID,
        JournalID,
        Period,
        AccumulatedNet,
        CurrencyOptions,
        TransactionDate,
    } = json;

    return [
        [
            {
                labels: ["Account ID"],
                value: AccountID,
                type: "string",
                basis: "10%",
            },
        ],
        [
            {
                labels: ["Transaction ID"],
                value: TransactionID,
                type: "string",
                basis: "10%",
            },
        ],
        [{ labels: ["Description"], value: Description, type: "string" }],
        [{ labels: ["Journal ID"], value: JournalID, type: "string", basis: "8%" }],
        [
            {
                labels: ["Transaction Date"],
                value: date(TransactionDate),
                type: "date",
                basis: "15%",
            },
        ],
        [{ labels: ["Period"], value: Period, type: "number", basis: "5%" }],
        [
            {
                labels: ["Debit amount"],
                value: formatCurrencyValues(CurrencyOptions, DebitAmount),
                type: "currency",
            },
        ],
        [
            {
                labels: ["Credit amount"],
                value: formatCurrencyValues(CurrencyOptions, CreditAmount),
                type: "currency",
            },
        ],
        [
            {
                labels: ["Balance"],
                value: formatCurrencyValues(CurrencyOptions, AccumulatedNet),
                type: "currency",
            },
        ],
    ];
};

const header = [
    { label: ["Account ID"], align: "left", basis: "10%" },
    { label: ["Transaction ID"], align: "left", basis: "10%" },
    { label: ["Description"], align: "left" },
    { label: ["Journal ID"], align: "left", basis: "8%" },
    { label: ["Transaction Date"], align: "center", basis: "15%" },
    { label: ["Period"], align: "center", basis: "5%" },
    { label: ["Debit amount"], align: "right" },
    { label: ["Credit amount"], align: "right" },
    { label: ["Accumulated Net"], align: "right" },
];

const mapper = (json, card) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
        link: {
            to:
                json.TransactionID && json.TransactionID !== "-1"
                    ? `/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix/transactional_data/transactions/${Buffer.from(
                          JSON.stringify({
                              [`CDM_Transactions.TransactionID`]: json.TransactionID,
                              [`CDM_Transactions.FKID`]: json.TransactionID,
                          }),
                      ).toString("base64")}`
                    : `/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix/master_data/general_ledger_accounts`,
            filter:
                json.TransactionID && json.TransactionID !== "-1"
                    ? undefined
                    : [{ filters: [{ value: json.AccountID }], column: "AccountID" }],
        },
    };
};

const statementaccountaccumulatedMapper = {
    map: mapper,
    header,
};

export default statementaccountaccumulatedMapper;
